export default function About() {
  const stats = [
    { number: '15,000', label: 'Active Traders', suffix: '+' },
    { number: '98', label: 'Payout Rate', suffix: '%' },
    { number: '$50M', label: 'Paid Out', suffix: '+' }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-gray-900 mb-4">
            Why QT Funded Stands Out
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of traders scaling their capital with industry-leading conditions and unmatched support
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="relative p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="text-center">
                <p className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-600 mb-3">
                  {stat.number}{stat.suffix}
                </p>
                <p className="text-lg text-gray-700 font-semibold">
                  {stat.label}
                </p>
              </div>
              {index < stats.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-px h-20 bg-gradient-to-b from-transparent via-gray-300 to-transparent transform -translate-y-1/2"></div>
              )}
            </div>
          ))}
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              icon: 'ri-shield-check-line',
              title: 'Trusted Platform',
              description: 'Regulated and secure trading environment with full transparency'
            },
            {
              icon: 'ri-rocket-line',
              title: 'Fast Payouts',
              description: 'Get your profits quickly with our streamlined payout process'
            },
            {
              icon: 'ri-team-line',
              title: 'Expert Support',
              description: '24/7 dedicated support team ready to help you succeed'
            },
            {
              icon: 'ri-line-chart-line',
              title: 'Flexible Rules',
              description: 'Trade with freedom and realistic profit targets'
            }
          ].map((feature, index) => (
            <div
              key={index}
              className="p-6 bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-200 hover:border-cyan-500/50 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
